<template>
  <table>
    <colgroup>
      <col width="80px" />
      <col width="200px" />
      <col v-for="(_, index) in columnTypes" :key="index" />
      <col width="100px" />
    </colgroup>
    <thead>
    <tr>
      <th>순번</th>
      <th>구분</th>
      <th v-for="(item, index) in columnTypes" :key="index">
        {{ item }}
      </th>
      <th>합계</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, index) in dataList" :key="index">
      <td>{{ index + 1 }}</td>
      <td>{{ item.구분 }}</td>
      <td v-for="(columnType, dIndex) in columnTypes" :key="dIndex">
        {{ item[columnType] }}
      </td>
      <td>{{ item.합계 }}</td>
    </tr>
    <tr>
      <th colspan="2">합계</th>
      <th v-for="(columnType, dIndex) in columnTypes" :key="dIndex">
        {{ dataList.reduce((sum, item) => sum + item[columnType], 0) }}
      </th>
      <th>{{ dataList.reduce((sum, item) => sum + item.합계, 0) }}</th>
    </tr>
    <tr>
      <th colspan="2">비율</th>
      <th v-for="(columnType, dIndex) in columnTypes" :key="dIndex">
        {{ calculatePercentage(columnType) }}%
      </th>
      <th>100%</th>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "pageChartTableSymptom",
  props: {
    dataList: {
      type: Array,
      required: true
    },
    columnTypes: {
      type: Array,
      required: true
    }
  },
  methods: {
    calculatePercentage(columnType) {
      const total = this.dataList.reduce((total, item) => total + item.합계, 0);
      if (!total) return '0.00';

      const columnSum = this.dataList.reduce((sum, item) => sum + item[columnType], 0);
      return ((columnSum / total) * 100).toFixed(2);
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 6px 4px;
  }

  th,
  tr.avg td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    background: #f9f9f9;
  }
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    background: white;
  }
}
</style>
